import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import ConnectBtn from '../../component/ConnectBtn';
import keyCircleImg from '../../assets/images/keyCircle2.svg';
import rocketImg from '../../assets/images/rocket.png';
import seetingCircleImg from '../../assets/images/seetingCircle2.svg';
import tvlIMg from '../../assets/images/tvlv2.svg';
import { useAccount } from 'wagmi';
import { Skeleton } from 'primereact/skeleton';

import fusionX from '../../assets/images/FusionX.png';
import agni from '../../assets/images/Agni.png';
import swapsicle from '../../assets/images/Swapsicle.png';
import aperture from '../../assets/images/ApertureSwap.png';
import uniswap from '../../assets/images/Uniswap.png';
interface NetworkOption {
  label: string;
  value: string;
  src: string;
}

function DexDetails() {
  const { address, isConnected } = useAccount();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const { chainName, exchangeName } = useParams();
  const navigate = useNavigate();

  const [networkOptions, setNetworkOptions] = useState<NetworkOption[]>([
    { label: 'Mantle', value: 'mantle', src: 'img/filter/mantleFilter.svg' },
    { label: 'Base', value: 'base', src: 'img/filter/baseFillter.svg' },
    { label: 'Telos', value: 'telos', src: 'img/filter/telosL.svg' },
    { label: 'Manta Network', value: 'manta-pacific', src: 'img/filter/mantaFilter.svg' },
    { label: 'Arbitrum', value: 'arbitrum', src: 'img/filter/arbitrum.svg' }
  ]);
  console.log("Lajsgat",networkOptions)
  const [network, setNetwork] = useState(chainName);
  const [dex, setDex] = useState<string>(rocketImg);

  console.log(network)

  const [totalTvlInUsd, setTotalTvlInUsd] = useState<number>(0);
  const [totalVault, setTotalVault] = useState<number>(0);


  const exchangeImageMap: { [key: string]: string } = {
    FusionX: fusionX,
    Agni: agni,
    ApertureSwap: aperture,
    Swapsicle: swapsicle,
    Uniswap: uniswap,
  };

  useEffect(() => {
    if (exchangeName && exchangeImageMap[exchangeName]) {
      setDex(exchangeImageMap[exchangeName]);
    } else {
      setDex(rocketImg);
    }
  }, [exchangeName, exchangeImageMap]);

  const getTwoDecimal = (num: any) => {
    const roundedNum = Math.floor(num * 100) / 100;
    return roundedNum;
  };

  const getFormatted = (x: any) => {
    if (isNaN(x)) return x;

    if (x < 999) {
      return getTwoDecimal(x);
    }

    if (x < 1000) {
      return getTwoDecimal(x);
    }

    if (x < 10000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 100000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 1000000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 10000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000000) {
      return getTwoDecimal(x / 1000000000) + "B";
    }

    return "1T+";
  };

  const loadData = (e: string) => {
    setNetwork(e);
    navigate(e);
  };

  const RadioInput = ({ label, value, src }: NetworkOption) => {
    return (
      <div className='radioSectionChild'>
        <input
          type="radio"
          checked={network === value}
          onChange={() => loadData(value)}
          id={value}
        />
        <label className='radioButtonLevel' htmlFor={value}>
          <img src={src} alt='' className='tvlChainFilter' />
          <span>{label}</span>
        </label>
      </div>
    );
  };

  return (
    <div className='custom-container'>
      <div className='second_section row mt-5 mb-5'>
        {/* <span className="redHatFont fnt_wgt_600 mb-2">TVL by Chain</span> */}
        <div className='flex align-items-center justify-content'>
          <div className="justify-content-center">
            <section className='radioSection'>
              {networkOptions
                .filter(option => option.value === network)
                .map((e, index) => (
                  <RadioInput  key={index} label={e.label} value={e.value} src={e.src} 
                  />
                ))}
            </section>
          </div>
          <div className=''><img src={dex} alt='tvl' width={200} className='dex_FullImage' /></div>
        </div>
        <div className='mb-5'>
          <Outlet context={{ setTotalVault, setTotalTvlInUsd }} />
        </div>
      </div>
    </div>
  );
}

export default DexDetails;
